import { render, staticRenderFns } from "./QuestionPhase.vue?vue&type=template&id=16c30d38&"
import script from "./QuestionPhase.vue?vue&type=script&lang=js&"
export * from "./QuestionPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports